"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.purchaseTypeMapper = void 0;
const enum_mapper_1 = require("../utils/enum-mapper");
const api_types_1 = require("@wix/wix-vod-constants/api-types");
const globalTypes_1 = require("../public/generated/globalTypes");
exports.purchaseTypeMapper = new enum_mapper_1.EnumMapper({
    [globalTypes_1.PurchaseType.RENT]: api_types_1.PaymentType.RENT,
    [globalTypes_1.PurchaseType.SALE]: api_types_1.PaymentType.PURCHASE,
    [globalTypes_1.PurchaseType.SUBSCRIPTION]: api_types_1.PaymentType.SUBSCRIPTION,
});
//# sourceMappingURL=purchase-type.js.map